<template>
  <BaseCustomizeMetal componentCode="I" />
</template>

<script>
import BaseCustomizeMetal from "@/components/customizeMetal/traditionalMetal/BaseCustomizeMetal/index.vue";
export default {
  name: "CustomizeMetalI",
  components: {
    BaseCustomizeMetal,
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .metal-text {
    top: 123px;
    left: 105px;
    @include betweenTableTablePro {
      top: 89px;
      left: 55px;
    }
    @include table {
      top: 72px;
      left: 30px;
    }
    @include phone {
      top: 60px;
      left: 14px;
    }
  }
  .templeName {
    height: 45px;
    width: 105px;
    .textContainer {
      width: 105px;
    }
  }
  .godName {
    width: 289px;
    height: 60px;
    .textContainer {
      width: 289px;
    }
  }
  .gift {
    width: 133px;
    height: 51px;
    position: absolute;
    right: -58px;
    bottom: -64px;
    .textContainer {
      width: 133px;
    }
  }
  .respect {
    position: absolute;
    bottom: -47px;
    left: -7px;
  }
}
</style>
